import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import ConstructReserveTooltip from '../ConstructReserveTooltip/ConstructReserveTooltip'

import { toCssClass } from 'helpers'
import { BONUS_TYPE_MESSAGES } from 'helpers/i18n.jsx'

import {
    BATTLE_TYPE_MESSAGES,
    BEFORE_PREFIX,
    CREW_EFFECTIVITY_BONUS,
    RANGE_OF_ACTION,
    INSPIRATION_INDUSTRIAL_RESOURCE_BONUS,
    ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS,
    RANGE_OF_AFFECTED_AREA,
    MAX_DAMAGE_FOR_VEHICLE_LEVELS,
} from './constants.jsx'
import { BATTLE_TYPES, BONUS_TYPES, MAX_BUILDING_LEVEL, RESERVE_TYPES } from 'constants'

import styles from './ConstructReserve.scss'


const ConstructReserve = ({ bonus, type, name, description }) => {
    const maxBonus = bonus.values[MAX_BUILDING_LEVEL - 1]

    const reserveDescription = (() => {
        if (!maxBonus.parameters) {
            return
        }

        switch (type) {
        case RESERVE_TYPES.ARTILLERY_STRIKE:
            return [
                MAX_DAMAGE_FOR_VEHICLE_LEVELS(maxBonus.parameters.maxDamage),
                RANGE_OF_AFFECTED_AREA(maxBonus.parameters.areaRadius),
                ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS(maxBonus.battle_types.battle_for_stronghold_and_sortie),
            ]
        case RESERVE_TYPES.INSPIRATION:
            return [
                CREW_EFFECTIVITY_BONUS(maxBonus.parameters.crewRolesFactor),
                RANGE_OF_ACTION(maxBonus.parameters.commonAreaRadius),
                INSPIRATION_INDUSTRIAL_RESOURCE_BONUS(maxBonus.battle_types.battle_for_stronghold_and_sortie),
            ]
        }
    })()

    return (
        <div className={cx(styles.base, styles[`base__${toCssClass(type)}`])}>
            <ConstructReserveTooltip
                reserveType={type}
                bonus={bonus}
            />
            <div className={styles.image} />
            <h3 className={styles.name}>{name}</h3>
            <p className={styles.description}>
                {description}
                <span className={styles.info} data-tip data-for={type} />
            </p>
            <div className={styles.bonuses}>
                {reserveDescription ? (
                    <div className={styles.bonus}>
                        {reserveDescription.map((description, index) => (
                            <div key={index}>{description}</div>
                        ))}
                    </div>
                ) : (
                    Object.keys(maxBonus.battle_types).map((battleType) => (
                        <div className={styles.bonus} key={`${battleType}_item`}>
                            <div className={styles.value}>
                                <div className={cx(styles.rate, styles.rate__prefix)}>
                                    {BEFORE_PREFIX}
                                </div>
                                <div className={cx(styles.rate, styles.rate__sign)}>{'+'}</div>
                                <div className={cx(styles.rate, styles.rate__value)}>
                                    {maxBonus.battle_types[battleType]}
                                </div>
                            </div>
                            <div className={styles.condition}>
                                <div className={styles.target}>{BONUS_TYPE_MESSAGES[bonus.type]}</div>
                                <div className={styles.where}>
                                    {
                                        (bonus.type === BONUS_TYPES.EXTRA_CREDITS &&
                                            battleType === BATTLE_TYPES.RANDOM_BATTLES) ?
                                        BATTLE_TYPE_MESSAGES[BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER] :
                                        BATTLE_TYPE_MESSAGES[battleType]
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}
ConstructReserve.propTypes = {
    name: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    bonus: PropTypes.object.isRequired,
}

export default ConstructReserve



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructReserve/ConstructReserve.jsx